<template>
  <div class="uk-width-1-2@m"
  >
    <div class="uk-padding-larger">
      <h4 class="
              uk-text-secondary-muted
              uk-text-uppercase
              uk-text-lighter
              uk-text-medium
              text-spacing-medium uk-margin-small-bottom
              juist-toon-zetten-title-text"
          v-if="subTitle.length > 0"
      >
        {{subTitle}}
      </h4>
      <h3 class="uk-margin-remove-top text-spacing-large
            uk-heading-small uk-text-lighter uk-text-uppercase uk-text-condensed
            tone-of-voice-text"
          :class="{'uk-text-secondary': !primary }"
      v-html="title"></h3>
      <p class="tone-of-voice-text" :class="{'uk-text-secondary': !primary }">
        <slot/>
      </p>
        <div class="voice-over-button uk-display-block small-button-white">
          <router-link :to="{ path: '/', hash: '#contactFormFour' }" class="
          voice-over-button-clickable-section uk-display-block small-button-white">
            <a class="voice-over-button-text small-button-white-text">Maak een afspraak</a>
          </router-link>
        </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'ImageSectionErvarenVoiceOver',
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    title: String,
    subTitle: {
      type: String,
      required: String,
    },
    buttonText: {
      required: false,
      type: String,
    },
    buttonLink: {
      required: false,
      type: String,
    },
  },
  computed: {
    buttonLinkParsed() {
      return this.buttonLink ?? '';
    },
  },
});
</script>
